import ItemsPage from './SharedItems/ItemsPage'
import * as React from 'react'

function ItemPageSales() {
  return <ItemsPage category={'Sale'} />
}

export default ItemPageSales
